<template>
    <div>
        <button class="open-calendar" :class="status" @click="open">Calendar</button>
        <div class="calendar" :class="status">
            <div class="title" @click="close">Upcoming events<i class="fas fa-times"></i></div>
            <div class="events">
                <div :class="row.class" v-for="row in rows">
                    <a v-if="row.slug" :href="row.slug">
                        <span v-if="row.content">{{ row.content }}</span>
                        <i v-if="row.on" class="date">{{ row.on }} <i class="fas fa-link"></i></i> <b v-if="row.name">{{ row.name }}</b>
                    </a>
                    <span v-else>
                        <span v-if="row.content">{{ row.content }}</span>
                        <i v-if="row.on" class="date">{{ row.on }}</i> <b v-if="row.name">{{ row.name }}</b>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            events: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                rows: [],
                status: 'closed'
            };
        },
        computed: {},
        mounted() {
            let currentMonth;

            for (let i = 0; i < this.events.length; i++) {
                let event = this.events[i];
                if (event.month !== currentMonth) {
                    this.rows.push({
                        class: 'month',
                        content: event.month,
                    });

                    currentMonth = event.month;
                }

                this.rows.push({
                    class: 'event',
                    on: event.on,
                    name: event.name,
                    slug: event.slug
                });
            }
        },
        methods: {
            open: function() {
                this.status = 'open';
            },
            close: function() {
                this.status = 'closed';
            }
        },
    };
</script>
